<template>
  <DxToolbar :items="toolbarItems" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { DxToolbar } from 'devextreme-vue/toolbar';

const props = withDefaults(defineProps<{
  isEditing: boolean,
  isDisabled?: boolean,
  allowEdit?: boolean,
}>(), {
  isEditing: false,
  isDisabled: false,
  allowEdit: true,
});

const emit = defineEmits(['editCanceled', 'saveClicked', 'editToggled']);

const toolbarItems = computed(() => {
  const items: any[] = [];

  if (!props.isEditing && !props.isDisabled && props.allowEdit) {
    items.push({
      location: 'after',
      locateInMenu: 'auto',
      widget: 'dxButton',
      options: {
        text: 'Editează',
        icon: 'edit',
        stylingMode: 'outlined',
        type: 'default',
        onClick: () => emit('editToggled')
      }
    });
  }

  if (props.isEditing) {
    items.push({
      location: 'after',
      locateInMenu: 'auto',
      widget: 'dxButton',
      options: {
        text: 'Salvează',
        stylingMode: 'outlined',
        type: 'default',
        onClick: (e: any) => emit('saveClicked', e)
      }
    });

    items.push({
      location: 'after',
      locateInMenu: 'auto',
      widget: 'dxButton',
      options: {
        text: 'Anulează',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: () => emit('editCanceled')
      }
    });
  }

  return items;
});
</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

.dx-toolbar {
  margin-bottom: var(--toolbar-margin-bottom);
}
</style>